// Re-export from ResultsTable so consumers import view-link helpers from one place.
export { getViewEmailLink } from '@apps/card/serviceCenter/routes/Messages/components/ResultsTable/ResultsTable.utils';

export function getSmsPreviewUrl(sentForEventId: string | null | undefined, id: string, sentOn?: number | null): string | null {
  if (!sentForEventId) return null;
  const basePath = `/${sentForEventId}/edit/messaging/sms-preview/${id}`;
  // Match the admin messaging route helper (getSmsPreviewPath): pass createAt epoch
  // as `sentOn` so SmsPreview can render the message timestamp.
  // sentOn is a numeric epoch, so it needs no URL encoding.
  return sentOn == null ? basePath : `${basePath}?sentOn=${sentOn}`;
}
